/**
 * Työmarkkinatori listings should always be treated as Finland in-scope.
 * Matches lambda `isTyomarkkinatoriSource` (URL is authoritative when the flag is missing).
 */
export function isTyomarkkinatoriJobSource(
  url: string | undefined | null,
  rawFlag?: boolean | string | null,
): boolean {
  if (rawFlag === true || rawFlag === 'true') {
    return true;
  }
  if (!url || typeof url !== 'string') {
    return false;
  }
  return url.includes('tyomarkkinatori.fi');
}

/** @deprecated Use applyTyomarkkinatoriSearchHitParity from utils/search */
export { applyTyomarkkinatoriSearchHitParity as applyTyomarkkinatoriFlagsToSearchHit } from '../search/apply-tyomarkkinatori-search-hit-parity';
